import React, { type ReactNode } from "react";
import U2000BasicDialog from "./U2000BasicDialog";
import { useTranslation } from "react-i18next";
import { FaCheck, FaTimesCircle } from "react-icons/fa";
import U2000ActionBtn from "../buttons/U2000ActionBtn";

interface U2000DeleteRecordDialogProps {
  isOpen: boolean;
  onClose: (result: "yes" | "no") => void;
  title: string;
  children?: ReactNode;
  width?: string | number;
}

const U2000DeleteRecordDialog: React.FC<U2000DeleteRecordDialogProps> = ({ isOpen, onClose, title, children, width }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  // Adapter to match U2000BasicDialog's onClose signature
  const handleClose = (reason: string) => {
    if (reason === "yes" || reason === "no") {
      onClose(reason);
    } else {
      onClose("no"); // Default to "no" if closed otherwise
    }
  };

  return (
    <U2000BasicDialog isOpen={isOpen} onClose={handleClose} title={title} width={width !== undefined ? String(width) : undefined}>
      <div className="flex flex-col items-center justify-center p-4 text-center">{children}</div>
      <div className="mt-2 flex justify-center gap-x-2 border-t-2 border-gray-300 p-4">
        <U2000ActionBtn label={t("dlgLblYes")} icon={FaCheck} handleClick={() => handleClose("yes")} />
        <U2000ActionBtn label={t("dlgLblNo")} icon={FaTimesCircle} handleClick={() => handleClose("no")} />
      </div>
    </U2000BasicDialog>
  );
};

export default U2000DeleteRecordDialog;
